import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import {
	PageView,
	NestedRouting,
	Divider,
	Box,
} from '@seeneco-ui/core';

import {
	createRoutes,
	componentsMap,
} from '@partners/routing';


export type PartnersEntryProps = {} & Partial<RouteComponentProps<{}>>;

const PartnersEntry: React.FC<PartnersEntryProps> = ({ match }) => {
	const routes = createRoutes(match.url);

	return (
		<PageView.Layout>
			<PageView.Content
				appearance='transparent'
				padding='0'
				fullWidth>
				<Divider />
				<Box width='100%'>
					<NestedRouting
						appearance='transparent'
						routes={routes}
						componentsMap={componentsMap}
					/>
				</Box>
			</PageView.Content>
		</PageView.Layout>
	);
}

PartnersEntry.displayName = 'PartnersEntry';
PartnersEntry.defaultProps = {};

export default withRouter(PartnersEntry);
